require('./mortgageRequestHomeOwnershipForm.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @constants
const { mortgageRequestPreApprovalCommons, homeOwnershipOptions } = require('constants/mortgageRequestPreApproval');

class MortgageRequestHomeOwnershipForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleOwner = this.handleOwner.bind(this);
        this.handleSecondOwner = this.handleSecondOwner.bind(this);
    }

    handleOwner(value) {
        this.props.formHandlers.handleOwner(value, mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE);
    }

    handleSecondOwner(value) {
        this.props.formHandlers.handleOwner(value, mortgageRequestPreApprovalCommons.HOLDER_OPTION_TWO);
    }

    buildOptions() {
        return Object.keys(homeOwnershipOptions).map((value) => ({
            value,
            label: formatText(homeOwnershipOptions[value])
        }));
    }

    buildHolderOneFields() {
        const { immMortgageRequest, validModal, responsiveMobileVersion } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const holder = mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE;
        const value = immMortgageRequest.getIn(['holders', holder, 'owner', 'value']);
        const options = this.buildOptions();
        const valid = validModal.getIn(['fields', holder, 'owner'], true) || validModal.getIn(['fields', holder, 'valid'], true);
        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-7 mortgage-request-marital-status-and-dependents__desktopVersion ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12  ' : ' col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitle  mortgage-request-marital-status-and-dependents__desktopVersionTitleHeight ';

        return (
            <div className='row'>
                <div className={cssContainerTitle}  >
                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-firstOwner" />
                        }
                    </div>

                </div>
                <div className={cssContainer}>
                    <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>

                        <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-homeOwnershipInput" />
                    </label>
                    <OKSelect
                        onChange={this.handleOwner}
                        options={options}
                        value={value}
                        errorState={!valid}
                        searchable={false}
                    />
                </div>
            </div>
        );
    }

    buildHolderTwoFields() {
        const { immMortgageRequest, validModal, responsiveMobileVersion } = this.props;
        const holder = mortgageRequestPreApprovalCommons.HOLDER_OPTION_TWO;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const options = this.buildOptions();
        const value = immMortgageRequest.getIn(['holders', holder, 'owner', 'value']);
        const valid = validModal.getIn(['fields', holder, 'owner'], true) || validModal.getIn(['fields', holder, 'valid'], true);
        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-7 mortgage-request-marital-status-and-dependents__desktopVersion ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitle ';
        return (
            <div className={!responsiveMobileVersion ? 'row mortgage-request-marital-status-and-dependents__margintop-15' : "row"}>
                <div className={cssContainerTitle}>

                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-secondOwner" />
                        }

                    </div>

                </div>
                <div className={cssContainer}>
                    {responsiveMobileVersion &&
                        <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                            <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-homeOwnershipInput" />
                        </label>
                    }
                    <OKSelect
                        onChange={this.handleSecondOwner}
                        options={options}
                        value={value}
                        errorState={!valid}
                        searchable={false}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { immMortgageRequest } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const holderOneFields = this.buildHolderOneFields();
        const holderTwoFields = selectedHolder !== mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE ? this.buildHolderTwoFields() : null;

        return (
            <div className="row mortgage-request-home-ownership-form">
                <div className="col-md-11">
                    <OKBoxTitle value={formatText('mortgageRequestPreApprovalStepThree-homeOwnership')} size="medium" />
                </div>
                <div className="container-fluid">
                    {holderOneFields}
                    {holderTwoFields}
                </div>
            </div>
        );
    }
}

MortgageRequestHomeOwnershipForm.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    validModal: PropTypes.object
}

module.exports = MortgageRequestHomeOwnershipForm;
